function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.1 22.6H24.8C24.3 20.8 22.6 19.5 20.7 19.5C18.8 19.5 17.1 20.8 16.6 22.6H1.2C0.5 22.6 0 23.1 0 23.8C0 24.5 0.5 25 1.2 25H16.7C17.2 26.8 18.9 28.1 20.8 28.1C22.7 28.1 24.4 26.8 24.9 25H28.2C28.9 25 29.4 24.5 29.4 23.8C29.4 23.2 28.8 22.6 28.1 22.6ZM20.8 25.7C19.8 25.7 19 24.9 19 23.9C19 22.9 19.8 22.1 20.8 22.1C21.8 22.1 22.6 22.9 22.6 23.9C22.6 24.9 21.8 25.7 20.8 25.7Z",
  fill: "url(#paint35_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.1 3.1H24.8C24.4 1.3 22.7 0 20.8 0C18.9 0 17.2 1.3 16.7 3.1H6.2C5.5 3.1 5 3.6 5 4.3C5 5 5.5 5.5 6.2 5.5H16.7C17.2 7.3 18.9 8.6 20.8 8.6C22.7 8.6 24.4 7.3 24.9 5.5H28.2C28.9 5.5 29.4 5 29.4 4.3C29.4 3.6 28.8 3.1 28.1 3.1ZM20.8 6.1C19.8 6.1 19 5.3 19 4.3C19 3.3 19.8 2.5 20.8 2.5C21.8 2.5 22.6 3.3 22.6 4.3C22.6 5.3 21.8 6.1 20.8 6.1Z",
  fill: "url(#paint36_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.1 12.8998H12.7C12.2 11.0998 10.5 9.7998 8.6 9.7998C6.7 9.7998 5 11.0998 4.5 12.8998H1.2C0.5 12.8998 0 13.3998 0 14.0998C0 14.7998 0.5 15.2998 1.2 15.2998H4.5C5 17.0998 6.7 18.3998 8.6 18.3998C10.5 18.3998 12.2 17.0998 12.7 15.2998H28.2C28.9 15.2998 29.4 14.7998 29.4 14.0998C29.4 13.3998 28.8 12.8998 28.1 12.8998ZM8.6 15.8998C7.6 15.8998 6.8 15.0998 6.8 14.0998C6.8 13.0998 7.6 12.2998 8.6 12.2998C9.6 12.2998 10.4 13.0998 10.4 14.0998C10.4 15.0998 9.6 15.8998 8.6 15.8998Z",
  fill: "url(#paint37_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.3 5.5C2 5.5 2.6 4.9 2.6 4.2C2.5 3.5 1.9 3 1.3 3C0.6 3 0 3.5 0 4.2C0 4.9 0.6 5.5 1.3 5.5Z",
  fill: "url(#paint38_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear",
  x1: 14.7,
  y1: 19.5,
  x2: 14.7,
  y2: 28.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint36_linear",
  x1: 17.2,
  y1: 0,
  x2: 17.2,
  y2: 8.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear",
  x1: 14.7,
  y1: 9.7998,
  x2: 14.7,
  y2: 18.3998,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint38_linear",
  x1: 1.3,
  y1: 3,
  x2: 1.3,
  y2: 5.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29.4,
  height: 28.1,
  fill: "white"
})));

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.6698be1c.svg";
export { ForwardRef as ReactComponent };